import { Grid, Stack, Typography } from "@mui/material";
import { MotionContainer, varBounce } from "../../../components/minimal/animate";
import { m } from "framer-motion";
import NoEventsIllustration from "../../../assets/illustrations/NoEventsIllustration";
import { Button } from "@mui/material";
import { useLocales } from "../../../locales";

const refreshPage = () => window.location.reload()

export const NotEnoughTicketsLeftMsg = () => {
    const { translate } = useLocales()

    return (
        <Grid item sx={{ margin: "20px auto", p: 2, textAlign: "center" }}>
            <Stack alignItems="center" component={MotionContainer}>

                <m.div variants={varBounce().in}>
                    <Typography variant="h4" paragraph sx={{ color: 'text.secondary' }}>
                        לצערנו נותרו פחות כרטיסים מהכמות שנבחרה
                    </Typography>
                    <Typography variant="h6" paragraph sx={{ color: 'text.secondary' }}>
                        נסו לבחור כמות כרטיסים קטנה יותר
                    </Typography>
                </m.div>

                <m.div variants={varBounce().in}>
                    <NoEventsIllustration
                        sx={{ my: 5 }}
                    />
                </m.div>

                <m.div variants={varBounce().in}>
                    <Button onClick={refreshPage} sx={{ width: "100%" }} size="large" variant="outlined">
                        {translate('event_page.error_fallback.action_btn_msg')}
                    </Button>
                </m.div>

            </Stack>
        </Grid>
    )
}
